import clsx from 'clsx';
import { forwardRef } from 'react';
import './styles.scss';

const CheckboxUI = forwardRef(function CheckboxUI({ children, checked, onChange, className }, ref) {
    return (
        <label className={clsx('checkbox-ui', className)}>
            <input
                ref={ref}
                type="checkbox"
                checked={checked}
                onChange={onChange}
            />
            <span className="checkbox-ui__text">{children}</span>
            <span className="checkbox-ui__checkmark">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 5.5L5.25 9.375L9.75 2.625" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </span>
        </label>
    );
});

export default CheckboxUI;
